var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hambuger_24px",
    transform: "translate(-372 -356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 24,
    height: 24,
    transform: "translate(372 356)",
    fill: "#f49b31",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1214",
    "data-name": "Rectangle 1214",
    width: 22,
    height: 22,
    transform: "translate(373 357)",
    fill: "#ffefdc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-outline",
    d: "M80,160H99.678M80,165.514H99.678M80,171.028H99.678",
    transform: "translate(294.161 202.486)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default __webpack_public_path__ + "static/media/burger-menu-icon.fe56188ecea92b34dbb9a58224190ffa.svg";
export { ForwardRef as ReactComponent };